export default __webpack_public_path__ + "static/today-neck-se-7bcb4b8899f4f7decfb6ec842ff8090c.jpg";